import React from "react";
import { BrandMark, Ico } from "./primitives.jsx";
import { navigate } from "./api.jsx";

const goToAuth = (mode) => navigate("auth", { authMode: mode });
const goToDashboard = () => navigate("dashboard");

export function Landing() {
  return (
    <div className="route-enter" style={{background:"var(--bg)"}}>
      {/* Top bar (landing) */}
      <div style={{
        display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"22px 40px", borderBottom:"1px solid var(--line)",
        position:"sticky", top:0, background:"var(--bg)", zIndex:10
      }}>
        <div style={{display:"flex", alignItems:"center", gap:10}}>
          <BrandMark size={26}/>
          <div style={{fontFamily:"var(--ff-h)", fontSize:20, letterSpacing:"-0.02em"}}>Venzyme<em style={{fontStyle:"italic", color:"var(--accent-hi)"}}>.LIFE</em></div>
        </div>
        <div style={{display:"flex", alignItems:"center", gap:28, fontSize:14, color:"var(--text-mute)"}}>
          <a href="#how-it-works" style={{cursor:"pointer"}}>How it works</a>
          <a onClick={() => goToAuth("register")} style={{cursor:"pointer"}}>For founders</a>
          <a onClick={() => goToAuth("register")} style={{cursor:"pointer"}}>For investors</a>
          <a href="/legacy/" style={{cursor:"pointer"}}>Research</a>
        </div>
        <div className="row" style={{gap:10}}>
          <button className="btn btn--quiet" onClick={() => goToAuth("login")}>Sign in</button>
          <button className="btn btn--primary" onClick={() => goToAuth("register")}>Request access</button>
        </div>
      </div>

      {/* Hero */}
      <section style={{padding:"110px 40px 80px", maxWidth:1280, margin:"0 auto"}}>
        <div className="h-eyebrow" style={{marginBottom:20}}>AI-native venture capital · Life sciences</div>
        <h1 className="h-display" style={{
          fontSize:"clamp(56px, 8vw, 108px)",
          lineHeight:.98,
          letterSpacing:"-0.035em",
          maxWidth:1100
        }}>
          The deck is the <em style={{fontStyle:"italic", color:"var(--accent-hi)"}}>first</em> diligence artifact.<br/>
          Treat it like one.
        </h1>
        <p style={{fontSize:22, lineHeight:1.5, color:"var(--text-mute)", maxWidth:720, marginTop:32}}>
          Venzyme evaluates therapeutic, diagnostic, device, and digital-health pitch decks with the same rigor a lead partner would bring — scored across seven axes, triangulated against live market research, auditable end-to-end.
        </p>
        <div className="row" style={{marginTop:40, gap:14}}>
          <button className="btn btn--primary" style={{padding:"14px 22px", fontSize:15}} onClick={() => goToAuth("register")}>Upload a deck <Ico n="arrow" size={14}/></button>
          <button className="btn btn--ghost" style={{padding:"14px 22px", fontSize:15}} onClick={() => navigate("audit")}>Learn more</button>
        </div>
      </section>

      {/* Instrument strip */}
      <section style={{padding:"40px 40px", borderTop:"1px solid var(--line)", borderBottom:"1px solid var(--line)", background:"var(--surface)"}}>
        <div style={{maxWidth:1280, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap:32}}>
          {[
            ["1,240+", "Decks evaluated"],
            ["7-axis", "Investment attractiveness score"],
            ["< 11 min", "Median extraction time"],
            ["0.87", "Avg. extraction confidence"],
          ].map(([v,l])=>(
            <div key={l}>
              <div style={{fontFamily:"var(--ff-h)", fontSize:46, letterSpacing:"-0.02em", lineHeight:1, fontVariationSettings:'"opsz" 144'}}>{v}</div>
              <div className="h-eyebrow" style={{marginTop:8}}>{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Proof strip — LP logos */}
      <section style={{padding:"54px 40px", borderBottom:"1px solid var(--line)"}}>
        <div style={{maxWidth:1280, margin:"0 auto"}}>
          <div className="h-eyebrow" style={{textAlign:"center", marginBottom:28, color:"var(--text-dim)"}}>
            In use at life-sciences venture firms and LPs
          </div>
          <div style={{
            display:"grid",
            gridTemplateColumns:"repeat(6, 1fr)",
            gap:32, alignItems:"center",
            opacity:.7
          }}>
            {[
              "POLARIS BIO",
              "MERIDIAN VC",
              "ATLAS LIFE",
              "HELIX PARTNERS",
              "FLAGSHIP HEALTH",
              "NORTHBRIDGE LP",
            ].map(name=>(
              <div key={name} style={{
                fontFamily:"var(--ff-h)",
                fontSize:15, fontWeight:500,
                letterSpacing:".12em",
                textAlign:"center",
                color:"var(--text-mute)",
                borderLeft: name !== "POLARIS BIO" ? "1px solid var(--line)" : "none",
                paddingLeft: 8
              }}>{name}</div>
            ))}
          </div>
        </div>
      </section>

      {/* Sample IAS + partner testimonial */}
      <section style={{padding:"100px 40px", background:"var(--surface)", borderBottom:"1px solid var(--line)"}}>
        <div style={{maxWidth:1280, margin:"0 auto", display:"grid", gridTemplateColumns:"1.1fr 1fr", gap:56, alignItems:"center"}}>

          {/* Sample IAS card */}
          <div className="card" style={{padding:"32px", background:"var(--bg)"}}>
            <div className="row" style={{justifyContent:"space-between", alignItems:"flex-start", marginBottom:20}}>
              <div>
                <div className="h-eyebrow" style={{marginBottom:6}}>Sample analysis · HLX-20260414</div>
                <div style={{fontFamily:"var(--ff-h)", fontSize:26, letterSpacing:"-0.01em"}}>Helix Therapeutics</div>
                <div style={{fontSize:13, color:"var(--text-mute)", marginTop:4}}>mRNA oncology · Series A · $18M</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontFamily:"var(--ff-h)", fontSize:56, lineHeight:1, color:"var(--accent-hi)", letterSpacing:"-0.02em", fontWeight:300}}>82</div>
                <div className="h-eyebrow" style={{marginTop:6, color:"var(--text-dim)"}}>IAS</div>
              </div>
            </div>

            {/* 7-axis mini bars */}
            <div style={{borderTop:"1px solid var(--line)", paddingTop:16, marginTop:8}}>
              {[
                ["Science & platform", 88, "Top 15%"],
                ["Team & execution", 79, "Top 30%"],
                ["Market & timing", 84, "Top 20%"],
                ["IP & moat", 61, "Gap"],
                ["Regulatory path", 72, null],
                ["Capital efficiency", 80, null],
                ["Commercial wedge", 74, null],
              ].map(([label, score, tag])=>(
                <div key={label} style={{
                  display:"grid", gridTemplateColumns:"1.3fr 2fr auto auto", gap:14,
                  alignItems:"center", padding:"7px 0",
                  fontSize:13
                }}>
                  <div>{label}</div>
                  <div style={{height:4, background:"var(--surface-2)", borderRadius:2, overflow:"hidden"}}>
                    <div style={{
                      height:"100%",
                      width:`${score}%`,
                      background: score < 65 ? "var(--warn)" : "var(--accent)"
                    }}/>
                  </div>
                  <div style={{fontFamily:"var(--ff-mono)", fontSize:12, color:"var(--text-mute)"}}>{score}</div>
                  <div style={{
                    fontFamily:"var(--ff-mono)", fontSize:10,
                    color: tag === "Gap" ? "var(--warn)" : "var(--text-dim)",
                    letterSpacing:".1em", minWidth:54, textAlign:"right",
                    whiteSpace:"nowrap"
                  }}>{tag || "—"}</div>
                </div>
              ))}
            </div>

            <div style={{
              marginTop:20, padding:"14px 16px",
              background:"var(--accent-soft)",
              borderLeft:"2px solid var(--accent)",
              fontSize:13, lineHeight:1.55
            }}>
              <span className="h-eyebrow" style={{color:"var(--accent-hi)", marginRight:8}}>Thesis</span>
              Strong preclinical + seasoned CMO; IP filing timeline is the single largest unresolved question before a term sheet.
            </div>
          </div>

          {/* Testimonial */}
          <div style={{paddingLeft:24}}>
            <div style={{
              fontFamily:"var(--ff-h)", fontSize:42, lineHeight:1.15,
              letterSpacing:"-0.015em", fontWeight:400,
              textWrap:"pretty"
            }}>
              <span style={{color:"var(--accent-hi)", fontStyle:"italic"}}>"</span>
              We used to spend the first 40 minutes of every Monday arguing about which decks to read. Now we spend it arguing about which <em style={{fontStyle:"italic", color:"var(--accent-hi)"}}>decisions</em> to make.
              <span style={{color:"var(--accent-hi)", fontStyle:"italic"}}>"</span>
            </div>
            <div style={{marginTop:28, display:"flex", alignItems:"center", gap:14}}>
              <div style={{
                width:44, height:44, borderRadius:"50%",
                background:"linear-gradient(135deg, var(--accent), var(--accent-hi))",
                color:"var(--text-invert)",
                display:"grid", placeItems:"center",
                fontFamily:"var(--ff-h)", fontSize:16
              }}>EM</div>
              <div>
                <div style={{fontSize:14, fontWeight:500}}>Dr. Elena Martín</div>
                <div style={{fontSize:13, color:"var(--text-mute)"}}>Managing Partner · Meridian VC</div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* How it works */}
      <section style={{padding:"100px 40px", maxWidth:1280, margin:"0 auto"}}>
        <div className="rule" style={{marginBottom:36}}>The method</div>
        <div className="grid grid--3" style={{gap:28, alignItems:"start"}}>
          {[
            ["01", "Extract", "We parse the deck structurally — not as a blob of text. Team, technology, clinical stage, raise, market, IP — each a first-class field with a confidence score."],
            ["02", "Triangulate", "Findings are checked against live market research, regulatory filings, comparable raises, and public-science sources. Gaps become questions, not assumptions."],
            ["03", "Score", "A 0-100 Investment Attractiveness Score across seven axes, weighted per modality, with every contributing datum traceable back to its source."],
          ].map(([n,t,d])=>(
            <div key={n}>
              <div style={{fontFamily:"var(--ff-mono)", fontSize:12, color:"var(--text-dim)", letterSpacing:".2em", marginBottom:14}}>{n}</div>
              <h3 className="h-display" style={{fontSize:"var(--text-2xl)", marginBottom:10}}>{t}</h3>
              <p style={{color:"var(--text-mute)", lineHeight:1.6}}>{d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Two-audience block */}
      <section style={{background:"var(--surface)", padding:"100px 40px", borderTop:"1px solid var(--line)"}}>
        <div style={{maxWidth:1280, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:48}}>
          <div className="card" style={{padding:"40px"}}>
            <div className="h-eyebrow">For founders</div>
            <h3 className="h-display" style={{fontSize:"var(--text-3xl)", margin:"12px 0 20px"}}>Know what investors will ask — <em>before</em> they ask.</h3>
            <p style={{color:"var(--text-mute)", lineHeight:1.6, marginBottom:24}}>Submit your deck and get a structured critique: the seven axes investors score against, the specific gaps they'll flag, and a draft of questions to be ready for.</p>
            <button className="btn btn--ghost" onClick={() => goToAuth("register")}>For founders →</button>
          </div>
          <div className="card" style={{padding:"40px", borderColor:"var(--line-accent)"}}>
            <div className="h-eyebrow">For investors</div>
            <h3 className="h-display" style={{fontSize:"var(--text-3xl)", margin:"12px 0 20px"}}>Spend your day on the three decks worth reading, <em>not</em> the thirty.</h3>
            <p style={{color:"var(--text-mute)", lineHeight:1.6, marginBottom:24}}>Triage inbound decks by modality, stage, and IAS. Every score is auditable, every claim is traced, every gap is flagged as a question — not glossed.</p>
            <button className="btn btn--primary" onClick={() => goToAuth("register")}>Request access →</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{padding:"40px", borderTop:"1px solid var(--line)", display:"flex", justifyContent:"space-between", fontSize:13, color:"var(--text-dim)"}}>
        <div>© 2026 Venzyme.LIFE</div>
        <div className="row" style={{gap:24}}>
          <span>Privacy</span><span>Terms</span><span>Security</span><span>Contact</span>
        </div>
      </footer>
    </div>
  );
}
